// extracted by mini-css-extract-plugin
export default {"main_container":"styles_main_container__4SeUx","navbar":"styles_navbar__4HaFG","navbar_buttons":"styles_navbar_buttons__ivvnP","navbar_button":"styles_navbar_button__mz6Y1"};